module.exports = __webpack_public_path__ + "images/BA_Tobacco-61e7bb.png";